// pages/components/support/SupportStats.jsx
import React from 'react';
import { TrendingUp, Clock, CheckCircle, XCircle, Loader2 } from 'lucide-react';

const SupportStats = ({ stats, loading }) => {
if (loading) {
return (
<div className="bg-white rounded-xl border border-slate-200 p-8 flex items-center justify-center">
<Loader2 className="animate-spin text-blue-600" size={32} />
</div>
);
}

if (!stats) return null;

const statCards = [
{
label: 'Total Tickets',
value: stats.total,
icon: TrendingUp,
color: 'blue',
bgColor: 'bg-blue-50',
iconBg: 'bg-blue-100',
iconColor: 'text-blue-600'
},
{
label: 'Open',
value: stats.byStatus.open,
icon: Clock,
color: 'green',
bgColor: 'bg-green-50',
iconBg: 'bg-green-100',
iconColor: 'text-green-600'
},
{
label: 'In Progress',
value: stats.byStatus.inProgress,
icon: Clock,
color: 'blue',
bgColor: 'bg-blue-50',
iconBg: 'bg-blue-100',
iconColor: 'text-blue-600'
},
{
label: 'Resolved',
value: stats.byStatus.resolved,
icon: CheckCircle,
color: 'purple',
bgColor: 'bg-purple-50',
iconBg: 'bg-purple-100',
iconColor: 'text-purple-600'
},
{
label: 'Closed',
value: stats.byStatus.closed,
icon: XCircle,
color: 'slate',
bgColor: 'bg-slate-50',
iconBg: 'bg-slate-100',
iconColor: 'text-slate-600'
}
];

return (
<div className="space-y-6">
<div className="bg-white rounded-xl border border-slate-200 p-6 shadow-sm">
<h2 className="text-2xl font-bold text-slate-900 mb-6">Support Overview</h2>

{/* Stats Grid */}
<div className="grid grid-cols-2 md:grid-cols-5 gap-4">
{statCards.map((stat, index) => {
const Icon = stat.icon;
return (
<div
key={index}
className={`${stat.bgColor} rounded-xl p-4 border border-${stat.color}-200 hover:shadow-md transition-all`}
>
<div className={`${stat.iconBg} w-10 h-10 rounded-lg flex items-center justify-center mb-3`}>
<Icon className={stat.iconColor} size={20} />
</div>
<p className="text-2xl font-bold text-slate-900 mb-1">{stat.value}</p>
<p className="text-sm text-slate-600">{stat.label}</p>
</div>
);
})}
</div>

{/* Latest Ticket Info */}
{stats.latestTicket && (
<div className="mt-6 p-4 bg-gradient-to-r from-blue-50 to-cyan-50 rounded-lg border border-blue-200">
<p className="text-sm font-semibold text-slate-900 mb-2">📌 Latest Ticket</p>
<div className="flex flex-col md:flex-row md:items-center md:justify-between gap-2">
<div>
<p className="font-mono text-xs text-slate-600 mb-1">{stats.latestTicket.ticketId}</p>
<p className="font-semibold text-slate-900">{stats.latestTicket.subject}</p>
</div>
<div className="flex items-center gap-3">
<span className={`px-3 py-1 rounded-full text-xs font-semibold ${
stats.latestTicket.status === 'open' ? 'bg-green-100 text-green-700' :
stats.latestTicket.status === 'in-progress' ? 'bg-blue-100 text-blue-700' :
stats.latestTicket.status === 'resolved' ? 'bg-purple-100 text-purple-700' :
'bg-slate-100 text-slate-700'
}`}>
{stats.latestTicket.status}
</span>
<span className="text-xs text-slate-600">
{new Date(stats.latestTicket.createdAt).toLocaleDateString()}
</span>
</div>
</div>
</div>
)}
</div>

{/* Quick Tips */}
<div className="bg-gradient-to-r from-green-50 to-emerald-50 rounded-xl border border-green-200 p-6">
<h3 className="font-bold text-green-900 mb-3 flex items-center gap-2">
<span className="text-xl">💡</span>
Quick Support Tips
</h3>
<ul className="space-y-2 text-sm text-green-800">
<li className="flex items-start gap-2">
<span className="text-green-600 mt-0.5">✓</span>
<span>Response time is typically under 24 hours</span>
</li>
<li className="flex items-start gap-2">
<span className="text-green-600 mt-0.5">✓</span>
<span>Check FAQs below for instant answers to common questions</span>
</li>
<li className="flex items-start gap-2">
<span className="text-green-600 mt-0.5">✓</span>
<span>You'll receive email updates on ticket progress</span>
</li>
</ul>
</div>
</div>
);
};

export default SupportStats;